module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/global_map_bg_with_news_cn.43c7e429.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/global_map_bg_with_news_cn.jpg
// module id = 2981
// module chunks = 11